(function () {
  const STORAGE_KEY = 'lavespera_cart_popup_shown';

  class LavesperaCartPopup {
    constructor(overlay) {
      this.overlay = overlay;
      this.modal = overlay.querySelector('.lavespera-cart-popup-modal');
      this.closeBtn = overlay.querySelector('.lavespera-cart-popup-close');
      this.delay = parseInt(overlay.dataset.delay || '3', 10) * 1000;
      this.showOnce = overlay.dataset.showOnce === 'true';
      this.patchCartDrawerOutsideClick();
      this.bind();
    }

    bind() {
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      // Modal içindeki pointer event'leri drawer'a ulaşmasın (bubble durur)
      // ama event butona inmeye devam eder (capture etkilenmez)
      if (this.modal) {
        ['mousedown', 'pointerdown', 'touchstart'].forEach(type => {
          this.modal.addEventListener(type, (e) => e.stopPropagation());
        });
      }

      // Overlay'e (karartma alanına) tıklanınca popup kapansın
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.overlay.classList.contains('is-active')) {
          this.close();
        }
      });
    }

    patchCartDrawerOutsideClick() {
      const applyPatch = () => {
        const cartDrawer = document.getElementById('cart-drawer');
        if (!cartDrawer || cartDrawer.dataset.cartPopupOutsideClickPatched === 'true') return;

        const originalHideForOutsideClickTarget = typeof cartDrawer.hideForOutsideClickTarget === 'function'
          ? cartDrawer.hideForOutsideClickTarget.bind(cartDrawer)
          : null;

        cartDrawer.hideForOutsideClickTarget = (target) => {
          if (target && typeof target.closest === 'function' && target.closest('#lavesperaCartPopup')) {
            return false;
          }

          return originalHideForOutsideClickTarget
            ? originalHideForOutsideClickTarget(target)
            : !cartDrawer.contains(target);
        };

        cartDrawer.dataset.cartPopupOutsideClickPatched = 'true';
      };

      if (window.customElements && typeof customElements.whenDefined === 'function') {
        customElements.whenDefined('cart-drawer').then(applyPatch).catch(() => {});
      } else {
        applyPatch();
      }
    }

    canShow() {
      if (this.showOnce && sessionStorage.getItem(STORAGE_KEY) === 'true') return false;
      if (window.Shopify && Shopify.designMode) return true;
      return true;
    }

    scheduleOpen() {
      if (!this.canShow()) return;
      setTimeout(() => this.open(), this.delay);
    }

    open() {
      this.patchCartDrawerOutsideClick();
      this.overlay.classList.add('is-active');
      if (this.showOnce) sessionStorage.setItem(STORAGE_KEY, 'true');
    }

    close() {
      this.overlay.classList.remove('is-active');
    }
  }

  function init(root) {
    const el = (root || document).querySelector('#lavesperaCartPopup');
    if (el && !el.dataset.initialized) {
      el.dataset.initialized = 'true';
      window.lavesperaCartPopup = new LavesperaCartPopup(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    const el = e.target.querySelector('#lavesperaCartPopup');
    if (el && window.lavesperaCartPopup) window.lavesperaCartPopup.open();
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const el = e.target.querySelector('#lavesperaCartPopup');
    if (el && window.lavesperaCartPopup) window.lavesperaCartPopup.close();
  });

  /* Sepete ekleme interceptor'u: ekleme öncesi sepet boş muydu? */
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const input = args[0];
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isCartAdd = url.includes('/cart/add');

    if (!isCartAdd) {
      return originalFetch.apply(this, args);
    }

    const wasEmptyPromise = originalFetch
      .call(this, `${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
      .then((r) => r.json())
      .then((cart) => (cart && typeof cart.item_count === 'number' ? cart.item_count === 0 : null))
      .catch(() => null);

    const addPromise = originalFetch.apply(this, args);

    Promise.all([wasEmptyPromise, addPromise.then((r) => r.clone()).catch(() => null)])
      .then(([wasEmpty, response]) => {
        if (!response || !response.ok) return;
        if (wasEmpty !== true) return;
        const popup = window.lavesperaCartPopup;
        if (popup) popup.scheduleOpen();
      })
      .catch(() => {});

    return addPromise;
  };
})();
